import { SurveyTableRow, useSurveyDownload } from "../../../hooks/api/surveys";
import { AnyObject } from "../../../store/auth";
import { downloadFromAnchor } from "../../../utils";
import { listAction } from "../../Common/Table";

export default function DownloadButton({
  record,
}: { record: SurveyTableRow } & AnyObject) {
  const surveyDownload = useSurveyDownload(record.id);

  const ActionButton = listAction.download;

  return (
    <>
      <ActionButton
        loading={surveyDownload.loading}
        title="Download survey"
        onClick={(e: React.MouseEvent) => {
          e.stopPropagation();
          surveyDownload.fetch().then((response) => {
            if (!response) return;

            downloadFromAnchor(response, `${record.title}`, "application/pdf");
          });
        }}
      />
    </>
  );
}
